import React, { useEffect, useState } from "react";
import SelectInput from "../../Global Functions/selectInput";
import { Link, useNavigate, useParams } from "react-router-dom";
import MainLayout from "../../Layout/mainLayout";
import TextInput from "../../Global Functions/textInput";
import { editNews, viewNews } from "../../Redux/Actions/newsAction";
import { useDispatch, useSelector } from "react-redux";
import {
  viewCityList,
  viewCountryListPagination,
  viewStateListPagination,
} from "../../Redux/Actions/settingsActions";
import AddImage from "../../Global Functions/addImage";
import { getProjectList } from "../../Redux/Actions/projectActions";
import { getEnums } from "../../Redux/Actions/enumsActions";
import { viewCategoryList } from "../../Redux/Actions/categoryActions";
import ImageShowerModal from "../../Global Functions/imageShowerModal";
import { DateToNormal, ToFirstCapital } from "../../Utils/helpers";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";
import toast from "react-hot-toast";

const EditNews = () => {
  const { id } = useParams();

  const [newsData, setNewsData] = useState({
    title: "",
    description: "",
    url: "",
    type: "",
    news_link: "",
    start_date: "",
    end_date: "",
    country: "",
    city: "",
    state: "",
  });

  const [selection, setSelection] = useState("");
  const navigate = useNavigate();

  const uploadOptions = ["file", "url"];

  const categoryOptions = ["trending", "what's new", "luxury"];

  const dispatch = useDispatch();

  const { countryList } = useSelector((state) => state.country || {});
  const { states } = useSelector((state) => state.states || {});
  const { cities } = useSelector((state) => state.city || {});
  const { enumsData } = useSelector((state) => state.enumsData || {});
  const { projects } = useSelector((state) => state.projects || {});

  const handleAddChange = (event) => {
    const { name, value } = event.target;
    setNewsData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const filteredNewsData = Object.fromEntries(
        Object.entries(newsData).filter(
          ([, value]) => value !== null && value !== undefined && value !== ""
        )
      );
      const response = await dispatch(editNews(filteredNewsData, id));
      if (response.statusCode === 200) {
        navigate("/news_and_articles");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    dispatch(viewNews(id));
  }, [dispatch, id]);

  const { news } = useSelector((state) => state.news || {});

  useEffect(() => {
    if (news?.data) {
      setNewsData({
        title: news.data.title || "",
        description: news.data.description || "",
        url: news.data.url || "",
        type: news.data.type || "",
        news_link: news.data.news_link || "",
        start_date: news.data.start_date || "",
        end_date: news.data.end_date || "",
        category: news.data.category || "",
        project: news.data.project || "",

        // IMPORTANT: set IDs, not objects
        country: news.data.country?._id || news.data.country || "",
        state: news.data.state?._id || news.data.state || "",
        city: news.data.city?._id || news.data.city || "",
      });
    }
  }, [news]);


  useEffect(() => {
    if (!newsData.state) {
      setNewsData((prev) => ({ ...prev, city: "" }));
      return;
    }

    dispatch(
      viewCityList({
        state: newsData.state,
        country: newsData.country,
        page: 1,
        limit: 200,
      })
    );
  }, [newsData.state, newsData.country, dispatch]);

  useEffect(() => {
    if (newsData.country) {
      dispatch(viewStateListPagination({ country: newsData.country }));
    }
  }, [newsData.country, dispatch]);


  console.log("DAAAYAYAYA", news)

  const handleFileUpload = async (event) => {
    const uploadedFile = event.target.files[0];

    const inputId = event.target.id;

    if (!uploadedFile) return;

    const responseUrl = await AddImage(uploadedFile);

    if (responseUrl) {
      setNewsData((prevData) => ({
        ...prevData,
        url: responseUrl,
        type: inputId === "image" ? "image" : "video",
      }));
    }
  };

  useEffect(() => {
    dispatch(getEnums());
  }, [dispatch]);

  useEffect(() => {
    if (!enumsData?.data?.ProjectStatus) return;

    const projectStatus = Object.values(enumsData.data.ProjectStatus);

    dispatch(
      getProjectList({
        status: projectStatus,
        page: 1,
        limit: 500,
        is_deleted: false,
      })
    );
  }, [dispatch, enumsData]);


  return (
    <MainLayout>
      <div
        style={{
          padding: "0px 20px",
          background: "white",
          borderRadius: "25px",
          gridColumn: "2/7",
          width: "100%"
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h1>Edit News/Article</h1>
          <Link to="/news_and_articles">
            <button className="button-class">View News List</button>
          </Link>
        </div>
        <form>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <div style={{ width: "50%" }}>
              <TextInput
                label="Title"
                value={newsData.title}
                name="title"
                required={true}
                type="text"
                placeholder="Enter Title"
                onChange={handleAddChange}
              ></TextInput>
            </div>
            <div style={{ width: "50%" }}>
              <SelectInput
                label="Select Country"
                placeholder="Select An Option"
                value={newsData.country}
                name="country"
                onChange={handleAddChange}
                options={
                  Array.isArray(countryList?.data)
                    ? countryList.data.map((country) => ({
                      label: country.country_name,
                      value: country._id,
                    }))
                    : []
                }
              ></SelectInput>
            </div>
          </div>
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <div style={{ width: "50%" }}>
              <SelectInput
                label="Select State"
                value={newsData.state}
                placeholder="Select An Option"
                onChange={handleAddChange}
                disabled={!newsData.country ? true : false}
                name="state"
                options={
                  Array.isArray(states?.data)
                    ? states.data.map((state) => ({
                      label: state.state_name,
                      value: state._id,
                    }))
                    : []
                }
              ></SelectInput>
            </div>
            <div style={{ width: "50%" }}>
              <SelectInput
                label="Select City"
                value={newsData.city}
                onChange={handleAddChange}
                name="city"
                disabled={!newsData.state ? true : false}
                placeholder="Select An Option"
                options={
                  Array.isArray(cities?.data)
                    ? cities.data.map((city) => ({
                      label: city.city_name,
                      value: city._id,
                    }))
                    : []
                }
              ></SelectInput>
            </div>
          </div>
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <div style={{ width: "50%" }}>
              <TextInput
                label="Start Date"
                onChange={handleAddChange}
                name="start_date"
                value={DateToNormal(newsData.start_date)}
                type="date"
              ></TextInput>
            </div>
            <div style={{ width: "50%" }}>
              <TextInput
                label="End Date"
                onChange={handleAddChange}
                name="end_date"
                value={DateToNormal(newsData.end_date)}
                type="date"
              ></TextInput>
            </div>
          </div>
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <div style={{ width: "50%" }}>
              <TextInput
                required={true}
                name="description"
                onChange={handleAddChange}
                value={newsData.description}
                label="Description"
              ></TextInput>
            </div>
            <div style={{ width: "50%" }}>
              <SelectInput
                placeholder="Select an Option"
                onChange={handleAddChange}
                name="project"
                value={newsData.project}
                label="Select Project"
                options={
                  Array.isArray(projects?.data)
                    ? projects.data.map((project) => ({
                      label: project.project_name,
                      value: project._id,
                    }))
                    : []
                }
              ></SelectInput>
            </div>
          </div>
          <div className="flex-container flex-justify-between margin-h-10 gap-10">
            <div style={{ width: "50%" }}>
              <SelectInput
                placeholder="Select an Option"
                onChange={handleAddChange}
                value={newsData.category}
                name="category"
                label="Select Category"
                options={
                  Array.isArray(categoryOptions)
                    ? categoryOptions.map((category) => ({
                      label: ToFirstCapital(category),
                      value: category,
                    }))
                    : []
                }
              ></SelectInput>
            </div>
            <div style={{ width: "50%" }}>
              <TextInput
                label="Enter News Link"
                placeholder="Add Link"
                value={newsData.news_link}
                onChange={handleAddChange}
                name="news_link"
              ></TextInput>
            </div>
          </div>
          <div style={{ width: "50%" }}>
            <SelectInput
              placeholder="Select To Upload"
              onChange={(event) => setSelection(event.target.value)}
              label="Select File/URL"
              options={
                Array.isArray(uploadOptions)
                  ? uploadOptions.map((cat) => ({
                    label: cat.toUpperCase(),
                    value: cat,
                  }))
                  : []
              }
            ></SelectInput>
          </div>

          {selection === "file" ? (
            <div className="flex-container flex-justify-between margin-h-10 gap-10">
              <div style={{ width: "50%" }}>
                <TextInput
                  forImage={true}
                  type="file"
                  disabled={newsData.url ? true : false}
                  span="Add Image"
                  id="image"
                  onChange={(event) => {
                    handleFileUpload(event);
                  }}
                  for="image"
                  label="Click to Upload Image"
                />
                {newsData.url && newsData.type === "image" ? (
                  <ImageShowerModalGlobal
                    file={newsData.url}
                    state={newsData}
                    setState={setNewsData}
                    keyField="image"
                  ></ImageShowerModalGlobal>
                ) : null}
              </div>
              <div style={{ width: "50%" }}>
                <TextInput
                  forImage={true}
                  type="file"
                  span="Add Video"
                  disabled={newsData.url ? true : false}
                  onChange={(event) => {
                    handleFileUpload(event);
                  }}
                  id="video"
                  for="video"
                  label="Click to Upload Video"
                />
                {newsData.url && newsData.type === "video" ? (
                  <ImageShowerModal
                    file={newsData.url}
                    onClick={() =>
                      setNewsData((prevData) => ({
                        ...prevData,
                        url: "",
                        type: "",
                      }))
                    }
                  />
                ) : null}
              </div>
            </div>
          ) : selection === "url" ? (
            <TextInput
              name="url"
              onChange={handleAddChange}
              value={newsData.url}
              label="Enter News URL"
            />
          ) : null}

          <div className="span2 flex-end margin-h-10">
            <Link to="/news_and_articles">
              <button className="button-class-white">Cancel</button>
            </Link>
            <button type="button" className="button-class" onClick={handleSubmit}>
              Save
            </button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default EditNews;
